$(document).ready(function () {

    $(".helpdeskform").submit(function (e) {
        e.preventDefault();

        $.ajax({
            url: "https://appapi.loqate.com/api/websites/gbg/contactmessagenew/",
            type: "post",
            async: true,
            //dataType:"JSON",
            data: $(this).serialize(),
            success: function (result) {
                if (result.url !== "") {
                    $(".helpdeskform").hide();
                    $("#ThankYouMessage").show();
                    //var headerheight = $('.navbar').outerheight() + 40;
                    //$('html,body').animate({
                    //    scrolltop: $("#helpdeskform").offset().top - headerheight
                    //});
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });

    });
});